
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    RANGEIRONPLAY_ACTION,
    FETCH_RANGEIRONPLAY,
    ADD_RANGEIRONPLAY,
    GET_RANGEIRONPLAY,
    EDIT_RANGEIRONPLAY,
    DELETE_RANGEIRONPLAY,
    RANGEFAIRWAY_ACTION,
    FETCH_RANGEFAIRWAY,
    ADD_RANGEFAIRWAY,
    GET_RANGEFAIRWAY,
    EDIT_RANGEFAIRWAY,
    DELETE_RANGEFAIRWAY,
    RANGEDRIVER_ACTION,
    FETCH_RANGEDRIVER,
    ADD_RANGEDRIVER,
    GET_RANGEDRIVER,
    EDIT_RANGEDRIVER,
    DELETE_RANGEDRIVER,
    RANGESPECIALITY_ACTION,
    FETCH_RANGESPECIALITY,
    ADD_RANGESPECIALITY,
    GET_RANGESPECIALITY,
    EDIT_RANGESPECIALITY,
    DELETE_RANGESPECIALITY,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Range Intervention Long Game Actions
 */

    export const fetchRangeIronPlay = (id, startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate
        }
        return (dispatch) => { 
            dispatch({ type:RANGEIRONPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchrangeironplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_RANGEIRONPLAY, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const addRangeIronPlay = (data, id) =>{
    
        var payload={
            "student":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGEIRONPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addrangeironplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeIronPlay(id)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_RANGEIRONPLAY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const getRangeIronPlay = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGEIRONPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getrangeironplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: GET_RANGEIRONPLAY, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editRangeIronPlay = (data, id, stdid) =>{
    
        var payload={
            "id":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGEIRONPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editrangeironplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeIronPlay(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_RANGEIRONPLAY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteRangeIronPlay = (id, stdid) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGEIRONPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleterangeironplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeIronPlay(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_RANGEIRONPLAY});                    
                }
                
                
            });
        
        }
    }
   

    // Fairway Intervention
    export const fetchRangeFairway = (id, startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate
        }
        return (dispatch) => { 
            dispatch({ type:RANGEFAIRWAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchrangefairway', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_RANGEFAIRWAY, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const addRangeFairway = (data, id) =>{
    
        var payload={
            "student":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGEFAIRWAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addrangefairway', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeFairway(id)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_RANGEFAIRWAY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const getRangeFairway = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGEFAIRWAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getrangefairway', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: GET_RANGEFAIRWAY, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editRangeFairway = (data, id, stdid) =>{
    
        var payload={
            "id":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGEFAIRWAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editrangefairway', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeFairway(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_RANGEFAIRWAY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteRangeFairway = (id, stdid) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGEFAIRWAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleterangefairway', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeFairway(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_RANGEFAIRWAY});                    
                }
                
                
            });
        
        }
    }

    // Range Driver
    export const fetchRangeDriver = (id, startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate
        }
        return (dispatch) => { 
            dispatch({ type:RANGEDRIVER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchrangedriver', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_RANGEDRIVER, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const addRangeDriver = (data, id) =>{
    
        var payload={
            "student":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGEDRIVER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addrangedriver', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeDriver(id)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_RANGEDRIVER});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const getRangeDriver = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGEDRIVER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getrangedriver', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: GET_RANGEDRIVER, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editRangeDriver = (data, id, stdid) =>{
    
        var payload={
            "id":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGEDRIVER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editrangedriver', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeDriver(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_RANGEDRIVER});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteRangeDriver = (id, stdid) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGEDRIVER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleterangedriver', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeDriver(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_RANGEDRIVER});                    
                }
                
                
            });
        
        }
    }

    // Range Speciality Shot
    export const fetchRangeSpeciality = (id, startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate
        }
        return (dispatch) => { 
            dispatch({ type:RANGESPECIALITY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchrangespeciality', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_RANGESPECIALITY, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const addRangeSpeciality = (data, id) =>{
    
        var payload={
            "student":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGESPECIALITY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addrangespeciality', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeSpeciality(id)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_RANGESPECIALITY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const getRangeSpeciality = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGESPECIALITY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getrangespeciality', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: GET_RANGESPECIALITY, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editRangeSpeciality = (data, id, stdid) =>{
    
        var payload={
            "id":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:RANGESPECIALITY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editrangespeciality', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeSpeciality(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_RANGESPECIALITY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteRangeSpeciality = (id, stdid) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:RANGESPECIALITY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleterangespeciality', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchRangeSpeciality(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_RANGESPECIALITY});                    
                }
                
                
            });
        
        }
    }


    